import { IconButton, Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { ApprovalValues } from '../../../types';
import { setNodeScrollState } from '../../Conditions';
import { FormView } from '../AddConditionNode/FormView';

export const UpdateCondition: React.FC<{
  approvalTypes: ApprovalSetupFlowCommonData | undefined;
  data: any;
}> = ({ approvalTypes, data }) => {
  const { getValues, setValue } = useFormContext<ApprovalValues>();
  const [visibility, setVisibility] = useState(false);
  const calloutId = useId(`update-condition-${data.id}`);

  const handleUpdateCondition = (formFields: any) => {
    const conditions = getValues('approvalSelectionConditions') || [];
    const nodeIndex = conditions.findIndex(
      (item) => item.importanceLevel === data.importanceLevel
    );

    const updatedConditions = [...conditions];
    if (updatedConditions[nodeIndex]) {
      updatedConditions[nodeIndex] = {
        ...updatedConditions[nodeIndex],
        ...formFields,
      };

      setValue('approvalSelectionConditions', updatedConditions, {
        shouldDirty: true,
      });
    }
    setNodeScrollState(true);
    setVisibility(false);
  };
  const handleUserRankUpdate = (newId: string) => {
    const conditions = getValues('approvalSelectionConditions') || [];
    const nodeIndex = conditions.findIndex(
      (item) => item.importanceLevel === data.importanceLevel
    );

    if (nodeIndex === -1) return; // no matching condition

    setValue(
      `approvalSelectionConditions.${nodeIndex}.requesterUserRankId`,
      newId,
      { shouldDirty: true }
    );
  };

  return (
    <Stack>
      <IconButton
        id={calloutId}
        iconProps={{ iconName: 'PageHeaderEdit' }}
        onClick={() => {
          setNodeScrollState(false);
          setVisibility(true);
        }}
      />
      <FormView
        data={data}
        onSave={handleUpdateCondition}
        approvalTypes={approvalTypes}
        onClose={() => {
          setNodeScrollState(true);
          setVisibility(false);
        }}
        visibility={visibility}
        handleUserRankUpdate={handleUserRankUpdate}
      />
    </Stack>
  );
};
